import React from 'react';
import styled from 'styled-components';
import Header from "../components/Heaader";
import Footer from "../components/Footer";
import {PageWrapper} from "../components/PageWrapper";
import {Main} from "../components/Main";
import ImageSlider from "../components/ImageSlider";
import NavBar from "../components/NavBar";
import Line from "../components/Line";
import {MainBody} from "../components/MainBody";
import {AllCaps} from "../components/AllCaps";


export default function LandingPage() {

    const image = "/images/d1.jpg"


    return (
        <PageWrapper>
            <Header/>
            <NavBar/>
            <MainBody>
                <Main>
                    <ImageSlider/>
                    <AllCaps>
                        <Heading>Ihr Partner für Tiefbau und Glasfaser in ganz Deutschland</Heading>
                        {/*<Subheading>Ihr Partner für Tiefbau und Glasfaser in ganz Deutschland</Subheading>*/}
                    </AllCaps>
                    <ContentWrapper>
                        <TextSection>
                            <Paragraph>
                                Willkommen bei der <strong>DaFa Rhein Sieg GmbH</strong>! Seit unserer Gründung im Jahr
                                2011 stehen wir für Qualität und Zuverlässigkeit im Baugewerbe. Seit 2021 haben wir
                                unseren Fokus gezielt auf den Tiefbau und die Glasfaserverlegung gelegt – Bereiche, in
                                denen wir uns durch langjährige Expertise und innovative Lösungen auszeichnen.
                            </Paragraph>
                            <Paragraph>
                                Mit einem Meister im Tiefbau in unserem festen Team garantieren wir nicht nur fundiertes
                                Fachwissen, sondern auch höchste Standards in der Ausführung. Unser festes und
                                eingespieltes Team arbeitet Hand in Hand, um Ihre Projekte effizient und präzise
                                umzusetzen.
                            </Paragraph>
                            <Paragraph>
                                Wir bringen umfangreiche Erfahrung im Tiefbau und der Glasfaserverlegung mit und decken
                                dabei das gesamte Spektrum ab – von der selbstständigen Arbeit inklusive moderner
                                Maschinentechnik bis zur Antragsverwaltung. Ganz gleich, ob es um komplexe
                                Infrastrukturprojekte oder die Feinheiten der Breitbanderschließung geht, wir sind Ihr
                                kompetenter Ansprechpartner.
                            </Paragraph>
                            <Paragraph>
                                Unser Einsatzgebiet erstreckt sich deutschlandweit. Wo immer Sie uns brauchen, wir sind
                                bereit, Ihre Anforderungen mit Engagement und Professionalität zu erfüllen.
                            </Paragraph>
                            <Paragraph>
                                Sprechen Sie uns an und lassen Sie uns Ihr Projekt gemeinsam planen!
                            </Paragraph>
                        </TextSection>

                        <ImageSection>
                            {/* Platzhalter für ein Bild */}
                            <img className="image" src={image}
                                 alt={<ImagePlaceholder>Bild kommt hier hin</ImagePlaceholder>}/>
                        </ImageSection>
                    </ContentWrapper>
                </Main>
            </MainBody>
            <Line/>
            <Footer/>
        </PageWrapper>
    );
}


const Heading = styled.h2`
    font-size: 2.5rem;
    color: #1a202c;
    margin-bottom: 1rem;
    font-weight: 700;
`;

const Subheading = styled.h3`
    font-size: 1.5rem;
    color: #4a5568;
    margin-bottom: 2rem;
    font-weight: 400;
`;


const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
        flex-direction: row;
        gap: 2rem;
    }
`;

const TextSection = styled.div`
    flex: 2;
`;

const Paragraph = styled.p`
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1rem;
    text-align: justify;
`;

const ImageSection = styled.div`
    flex: 1;
    margin-top: 2rem;
    max-width: 400px;
    height: auto;

    .image {
        width: 100%;
        height: auto;
    }

    @media (min-width: 768px) {
        margin-top: 0;
    }
`;

const ImagePlaceholder = styled.div`
    width: 100%;
    height: 240px;
    background-color: #e2e8f0;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #718096;
    font-size: 1rem;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.03);
    transition: all 0.3s ease;

    &:hover {
        background-color: #cbd5e0;
        color: #2d3748;
    }
`;


